import type { PostHog } from 'posthog-js';
import type { SignupFunnelEventName, TrackingEventData } from 'types/tracking';
import { captureAnalyticsEvent } from 'utils/captureAnalyticsEvent';

type CaptureSignupFunnelEventContext = {
    url?: string;
};

type CaptureSignupFunnelEventOptions = {
    insertId?: string;
};

/** Captures signup funnel events via PostHog when initialized, otherwise via the /collect beacon. */
export const captureSignupFunnelEvent = <T extends SignupFunnelEventName>(
    posthog: PostHog | null | undefined,
    eventName: T,
    data?: TrackingEventData<T>,
    context?: CaptureSignupFunnelEventContext,
    options?: CaptureSignupFunnelEventOptions
): string =>
    captureAnalyticsEvent(
        posthog,
        eventName,
        {
            ...(data as Record<string, unknown> | undefined),
            url: context?.url,
        },
        options
    );
